// extracted by mini-css-extract-plugin
export default {"navAction":"brand-header-GlobalNavActions__navAction--WyZSa","hiddenOnMobile":"brand-header-GlobalNavActions__hiddenOnMobile--2rrAA"};